<template>
    <div  @click="$emit('cancel')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-40 backdrop-blur-[2px]">
    </div>
    <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
        <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
            <div class="pafcpic_header bg-[#006A00] py-3 px-6">
                <p  v-if="edit" class="text-[#ffffff] text-md font-bold">UPDATE LEAVE RECORD</p>
                <p  v-else class="text-[#ffffff] text-md font-bold">ADD LEAVE RECORD</p>
            </div>
      
            <div class="pafcpic_body py-3 px-6">
              
                <p class="text-xs text-[#818181] ml-1 font-medium ">FROM DATE</p>
                <input type="date" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none mb-1"                                 v-model="fromdate" @change="countDuration(fromdate,todate)">
                <p class="text-xs text-[#818181] ml-1 font-medium ">TO DATE</p>
                <input type="date" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none mb-1"                                 v-model="todate" @change="countDuration(fromdate,todate)">
                <p class="text-xs text-[#818181] ml-1 font-medium ">PARTICULARS</p>
                <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none mb-1" placeholder="ENTER PARTICULARS" v-model="particular">
                <p class="text-xs text-[#818181] ml-1 font-medium ">Days</p>
                <input type="number" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none mb-1" placeholder="00"              v-model="days">
                <p class="text-xs text-[#818181] ml-1 font-medium ">UNDERTIME (hh:mm)</p>
                <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none mb-1" placeholder="00:00"             v-model="undertime" @input="formatTime">
                <p class="text-xs text-[#818181] ml-1 font-medium ">LATE (hh:mm)"</p>
                <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none mb-1" placeholder="00:00"             v-model="late" @input="formatTimes">
                <p class="text-xs text-[#818181] ml-1 font-medium ">REMARKS</p>
                <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none mb-1" placeholder="LZREYES"           v-model="remarks">
            </div>
        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
            <!-- <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md"  v-show="EditorAdd === 'Edit'" v-on:click="UpdateAccount">Update</button> -->
            <button v-if="edit" class="text-sm text-white bg-[#006A00] py-1.5 px-7 rounded-md" @click="$emit('editLeaveRecord',id,fromdate,todate,particular,days,undertime,late,remarks)">UPDATE</button>
            <button v-else class="text-sm text-white bg-[#006A00] py-1.5 px-7 rounded-md" @click="$emit('addLeaveRecord',fromdate,todate,particular,days,undertime,late,remarks)">ADD</button>
            <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" @click="$emit('cancel')">Cancel</button>
        </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({

    data(){
        return{
            fromdate:   '',
            todate:     '',
            particular: '',
            days:       '',
            undertime:  '',
            late:       '',
            remarks:    '',
            editData: null,
            reformattedDate: null,
            id:'',
        }
    },
    props:{
            data:{
                type: Object,
                default: null,
            },
            edit:{
                type: Boolean,
                default: false,
            }
    },
    mounted(){
           this.editData = this.data
           this.editInformation()
    },
    methods:{
        editInformation(){
            if(this.editData != null){
                this.editData = this.data[0]
                this.id = this.editData.id
                this.fromdate = this.formatdate(this.editData.fromdate)
                this.todate = this.formatdate(this.editData.todate)
                this.particular = this.editData.particular
                this.days = this.editData.days
                this.undertime = this.editData.undertime
                this.late = this.editData.late
                this.remarks = this.editData.remarks     
            }
                 
        },
        formatdate(date){
            var dateString = date;
            var dateComponents = dateString.split('-');
            return this.reformattedDate = dateComponents[2] + '-' + dateComponents[0] + '-' + dateComponents[1];
        },
        addleaverecord(){
            alert("naclick")
        },
        countDuration(fromDate, toDate) {
           
           const startDate = new Date(fromDate);
           const endDate = new Date(toDate);

           const totalDays = (endDate - startDate) / (1000 * 3600 * 24) + 1;
           let workingDays = totalDays;
           
           for (let i = 0; i < totalDays; i++) {
               const tempDate = new Date(startDate);
               tempDate.setDate(startDate.getDate() + i);
               if (tempDate.getDay() === 0 || tempDate.getDay() === 6) {
               workingDays--;
               }
           }
           this.days = workingDays
           
       },
       formatTime() {
                
                var sanitized = this.undertime.replace(/[^0-8]/g, "");

                // Ensure that hours are between 00 and 08
                var hours = sanitized.slice(0, 2).padStart(2, "0");

                // Ensure that minutes are between 00 and 59
                var minutes = sanitized.slice(2, 4).padStart(2, "0");

                // Check if the time exceeds the limit of 08:00
                if (parseInt(hours) > 8 || (parseInt(hours) === 8 && parseInt(minutes) > 59)) {
                    hours = "08";
                    minutes = "00";
                }

                // Update the input value
                this.undertime = hours + ":" + minutes;
            },
            formatTimes() {
                
                var sanitized = this.late.replace(/[^0-8]/g, "");

                // Ensure that hours are between 00 and 08
                var hours = sanitized.slice(0, 2).padStart(2, "0");

                // Ensure that minutes are between 00 and 59
                var minutes = sanitized.slice(2, 4).padStart(2, "0");

                // Check if the time exceeds the limit of 08:00
                if (parseInt(hours) > 8 || (parseInt(hours) === 8 && parseInt(minutes) > 59)) {
                    hours = "08";
                    minutes = "00";
                }

                // Update the input value
                this.late = hours + ":" + minutes;
            },
    }

})

</script>